import { Component, input } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'eiq-colored-circle-icon',
  templateUrl: './colored-circle-icon.component.html',
  styleUrls: ['./colored-circle-icon.component.scss', './_colored-circle-icon-theme.component.scss']
})
export class ColoredCircleIconComponent {
  color = input<'primary' | 'light'>('primary');
  faIcon = input<IconDefinition>(null);
  svgIcon = input<string>(null);
}
